import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getEntityIconsByType } from "orion-components/GlobalData/Selectors";

const ColorFrames = ({ handleColorSelection, pickedColor }) => {
	const [selectedColor, setSelectedColor] = useState("");

	const colors = useSelector((state) => getEntityIconsByType(state)("frame_colors"));

	useEffect(() => {
		if (pickedColor !== "") {
			setSelectedColor(colors[pickedColor]?.color || "");
		}
	}, [pickedColor]);

	return Object.entries(colors).map(([, value], index) => {
		const { color, id } = value;
		return (
			<div
				className="type-color-style"
				key={index}
				style={{
					...{
						backgroundColor: color,
						border: selectedColor == color ? "2px solid #fff" : null
					}
				}}
				onClick={() => {
					setSelectedColor(color);
					handleColorSelection(id);
				}} data-testid="orion-components-shared-components-entity-icons-color-frames-div"
			></div>
		);
	});
};

export default ColorFrames;
